import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Form, Formik } from "formik";
import { useSelector } from "react-redux";
import { ResourceLoading } from "../../../utils/ResourceLoading";
import { excelReports } from "../../../../api/service/report";
import { PMDialog } from "../../../utils/PMDialog";
import { runExportReportsExcelOperation } from "./runExportReportsExcelOperation";

export const ReportExportDialog = (props) => {
  const { onClose, open, controller } = props;
  const { t } = useTranslation();
  const currentCompany = useSelector((state) => state.session.currentCompany);
  const [isLoading, setIsLoading] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);

  const initialValues = {
    printReport: true,
    print_report_type: "",
    submit: null,
  };

  const runExport = async () => {
    setIsLoading(true);
    setPdfUrl(null);
    try {
      await runExportReportsExcelOperation({
        controller,
        companyId: currentCompany?.id,
        t,
        exportFn: excelReports,
        onExported: ({ excelUrl }) => {
          if (excelUrl) setPdfUrl(excelUrl);
        },
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownloadPDF = () => {
    if (pdfUrl) window.open(pdfUrl, "_blank");
  };

  return (
    <PMDialog open={open} onClose={onClose}>
      <Formik initialValues={initialValues} onSubmit={() => {}}>
        {() => (
          <Form>
            <div className="grid grid-cols-6 gap-6 mt-10">
              <div className="col-span-6 sm:col-span-6">
                <button
                  type="button"
                  onClick={() => runExport()}
                  disabled={isLoading}
                  className="w-full justify-center rounded-md border border-transparent bg-blue-400 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-sm disabled:opacity-50"
                >
                  {t("Export Excel")}
                </button>
              </div>
              <div className="col-span-6 sm:col-span-6 mb-20">
                {isLoading ? (
                  <ResourceLoading />
                ) : (
                  pdfUrl && (
                    <button
                      type="button"
                      className="w-full justify-center rounded-md border border-transparent bg-emerald-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-sm"
                      onClick={handleDownloadPDF}
                    >
                      {t("Download")}
                    </button>
                  )
                )}
              </div>
            </div>
            <div className="mt-20 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
              <button
                type="button"
                className="inline-flex justify-center w-20 rounded-md border border-transparent bg-gray-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-sm"
                onClick={onClose}
              >
                {t("Close")}{" "}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </PMDialog>
  );
};
